export const strong = (text: string) => `<strong>${text}</strong>`
